__turbopack_context__.v({
  "header": "hide-and-seek-module__cPQP6a__header",
  "root": "hide-and-seek-module__cPQP6a__root",
  "subtitle": "hide-and-seek-module__cPQP6a__subtitle",
  "title": "hide-and-seek-module__cPQP6a__title",
});
